import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarWeekDaysRowFn = /* @__PURE__ */ createRecipe('calendar-week-days-row', {}, [])

const calendarWeekDaysRowVariantMap = {}

const calendarWeekDaysRowVariantKeys = Object.keys(calendarWeekDaysRowVariantMap)

export const calendarWeekDaysRow = /* @__PURE__ */ Object.assign(memo(calendarWeekDaysRowFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarWeekDaysRow',
  __getCompoundVariantCss__: calendarWeekDaysRowFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarWeekDaysRowVariantKeys,
  variantMap: calendarWeekDaysRowVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarWeekDaysRowVariantKeys)
  },
  getVariantProps: calendarWeekDaysRowFn.getVariantProps,
})